const translationsData = require('../intl/bg.json');

export const ALL_FAQ_QUESTIONS: string[] =
  Object.keys(translationsData.frequently_asked_questions.data_list) || [];
